import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { CustomerSubscriptionItem } from "src/app/shared/models/CustomerSubscription.item";

@Component({
	selector: "app-subscription-list",
	templateUrl: "./subscription-list.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class SubscriptionListComponent implements OnInit {
	bulkEdit: boolean = false;

	subscriptionRecordSelected: CustomerSubscriptionItem;
	subscriptionRecordsSelected: CustomerSubscriptionItem[];

	constructor(public app: AppService, public customerService: CustomerService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		if (!this.customerService.initatiatedVenueKey || this.customerService.initatiatedVenueKey !== this.venueService.venueKey) {
			this.customerService.initCustomerService();
		}
		if (this.customerService.initatiatedVenueKey && this.customerService.customerSubscriptionItemList.value.length === 0) {
			this.customerService.subscriptionsGetAll();
		}
	}

	onBulkEdit() {
		this.bulkEdit = false;
		if (this.subscriptionRecordsSelected.length === 1) {
			this.subscriptionRecordSelected = this.subscriptionRecordsSelected[0];
		} else {
			console.log("fired");
			this.bulkEdit = true;
		}
	}

	onRunItemsNow() {
		this.app.confirmation.confirm({
			message: `Run ${this.subscriptionRecordsSelected.length} subscriptions now?`,
			accept: async () => {
				this.subscriptionRecordsSelected.forEach((subscriptionItem) => {
					subscriptionItem.nextBillDate = this.app.moment.unix();
					subscriptionItem.nextBillDateDate = this.app.moment.unix(subscriptionItem.nextBillDate).toDate();
					this.customerService.subscriptionSave(subscriptionItem);
				});
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}
}
